import { httpClient } from '@/services/http/httpClient'

type CreatePortfolioColumnData = {
  portfolioId: string
  title: string
}

export async function createPortfolioColumn({
  portfolioId,
  title,
}: CreatePortfolioColumnData) {
  await httpClient.post(`/projects/portfolio-columns`, { portfolioId, title })
}
